import { Injectable } from "@angular/core";
import moment from "moment";
@Injectable({
  providedIn: "root"
})
export class HelperService {
  constructor() {}

  sortArray(array: Array<any>, field: string): Array<any> {
    return array.sort((a, b) => (a[field] > b[field] ? 1 : -1));
  }

  sortArrayDescendent(array: Array<any>, field: string): Array<any> {
    return array.sort((a, b) => (b[field] > a[field] ? 1 : -1));
  }

  returnNFirstChars(text: string, numberChars: number): string {
    if (text.length < numberChars) {
      return text;
    } else {
      return `${text.substr(0, numberChars)} ...`;
    }
  }

  normalizeWord(word: string): string {
    const replace = /\ /gi;
    return word
      .trim()
      .replace(replace, "-")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  }

  getPastWeeks(date: string): number {
    const normalizedDate = new Date(date);
    return moment().diff(moment(normalizedDate), "weeks");
  }

  getPastDays(date: string): number {
    const normalizedDate = new Date(date);
    return moment().diff(moment(normalizedDate), "day");
  }

  same(date: string, unit: any): boolean {
    const normalizedDate = new Date(date);
    return moment().isSame(moment(normalizedDate), unit);
  }

  alertRange(date: string): string {
    if (this.same(date, "day")) {
      return "today";
    }
    if (2 > this.getPastDays(date)) {
      return "yesterday";
    }
    if (this.same(date, "week")) {
      return "week";
    }
    return "older";
  }

  highlightSearch(wholeText: string, search: string): string {
    const searchIndex = this.normalizeWord(wholeText).indexOf(
      this.normalizeWord(search)
    );
    if (searchIndex < 10) {
      return `<div style="width: 100%; display: flex">${wholeText.substr(
        0,
        searchIndex - 1
      )} <b style="background: grey; color: white">${wholeText.substr(
        searchIndex,
        search.length
      )}</b>${wholeText.substr(
        searchIndex + search.length,
        wholeText.length - (searchIndex + search.length)
      )}</div>`;
    } else {
      return `<div style="width: 100%; display: flex">... ${wholeText.substr(
        searchIndex - 10,
        10
      )} <b style="background: grey; color: white">${wholeText.substr(
        searchIndex,
        search.length
      )}</b>${wholeText.substr(
        searchIndex + search.length,
        wholeText.length - (searchIndex + search.length)
      )}</div>`;
    }
  }
}
